import {PlayerColor} from '@colonist/game-states'
import {ImageURL} from '@colonist/types'
import CityRed from '@static/images/city_red.svg'
import CityBlue from '@static/images/city_blue.svg'
import CityOrange from '@static/images/city_orange.svg'
import CityGreen from '@static/images/city_green.svg'
import CityBlack from '@static/images/city_black.svg'
import CityBronze from '@static/images/city_bronze.svg'
import CitySilver from '@static/images/city_silver.svg'
import CityGold from '@static/images/city_gold.svg'
import CityWhite from '@static/images/city_white.svg'
import CityPurple from '@static/images/city_purple.svg'
import CityMysticBlue from '@static/images/city_mysticblue.svg'
import CityPink from '@static/images/city_pink.svg'

export const CITY_IMAGE_PATH: Record<PlayerColor, ImageURL> = {
    [PlayerColor.None]: '' as ImageURL,
    [PlayerColor.Red]: CityRed,
    [PlayerColor.Blue]: CityBlue,
    [PlayerColor.Orange]: CityOrange,
    [PlayerColor.Green]: CityGreen,
    [PlayerColor.Black]: CityBlack,
    [PlayerColor.Bronze]: CityBronze,
    [PlayerColor.Silver]: CitySilver,
    [PlayerColor.Gold]: CityGold,
    [PlayerColor.White]: CityWhite,
    [PlayerColor.Purple]: CityPurple,
    [PlayerColor.MysticBlue]: CityMysticBlue,
    [PlayerColor.Pink]: CityPink,
}
